var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.isThemeSfr
        ? _c("SfrLogoSvg", {
            attrs: { height: _vm.height, width: _vm.width, isDark: _vm.isDark },
          })
        : _vm.isThemeCatsafe
        ? _c("CatsafeLogoSvg", {
            attrs: { height: _vm.height, width: _vm.width, isDark: _vm.isDark },
          })
        : _c("BeepizLogoSvg", {
            attrs: { height: _vm.height, width: _vm.width, isDark: _vm.isDark },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }